import { connect } from 'react-redux'
import {
  getAudioPanelErrorStatus,
  getAudioPanelLoadingStatus,
  getEventsData,
  getEnergyData,
  mapCommentsData,
  mapSpeechHitsData,
  getIsAudioDelayed,
  getAudioPanelEnergyErrorStatus,
} from './audioPanel.selectors'

import { getAudioEnergy } from './energy.actions'
import { getComments, getCommentsSuccess } from './comments.actions'

import AudioPanel, { UnstyledAudioPanel } from './AudioPanel'
import { withAuthenticatedUser, PERMISSIONS } from '../../../Permissions'

const mapStateToProps = state => {
  return {
    loading: getAudioPanelLoadingStatus(state),
    error: getAudioPanelErrorStatus(state),
    energyError: getAudioPanelEnergyErrorStatus(state),
    events: getEventsData(state),
    energy: getEnergyData(state),
    comments: mapCommentsData(state),
    speechHits: mapSpeechHitsData(state),
    isAudioDelayed: getIsAudioDelayed(state),
  }
}

const mapDispatchToProps = (dispatch, { authenticatedUser: { hasPermission } }) => ({
  async onContactUpdate(contactId, durationMs, storageFileOffsetMs, zoomed, isRootRecording) {
    const msToSWith2Decimals = ms => Math.floor(ms / 10) / 100

    const duration = msToSWith2Decimals(durationMs)
    const offset = msToSWith2Decimals(storageFileOffsetMs)

    //Data points when zoomed are 320 every 60 seconds
    const dataPoints = zoomed ? Math.ceil(Math.max(durationMs / 60000, 1) * 320) : 320

    const audioEnergy = dispatch(getAudioEnergy(contactId, duration, dataPoints, offset, isRootRecording))

    await audioEnergy
  },
  async onEvalUpdate(contactId, evalId) {
    //Simulate a dispatch so that loading stops
    const comments =
      evalId && hasPermission(PERMISSIONS.VIEW_EVALUATIONS)
        ? dispatch(getComments(contactId, evalId))
        : dispatch(getCommentsSuccess([]))
    await comments
  },
})

export { UnstyledAudioPanel }

export default withAuthenticatedUser(connect(mapStateToProps, mapDispatchToProps)(AudioPanel))
